import { MutationTree } from 'vuex';
import { EventLogState } from './types';
import { SearchParams } from '@/shared/model/searchParams';
import { deepClone } from '@/shared/utils/generalUtils';
import logEntry, { LogEntry } from '@/shared/model/logEntry';

export const mutations: MutationTree<EventLogState> = {
  setEventLogAllEntries(state, payload: LogEntry[]) {
    state.allLogEntries = payload.map(logEntry.parse);
  },
  setEventLogFilteredEntries(state, payload: LogEntry[]) {
    state.filteredLogEntries = payload;
  },
  setEventLogCurrentPageEntries(state, payload: LogEntry[]) {
    state.currentPageLogEntries = payload;
  },
  setEventLogIsLoading(state, payload: boolean) {
    state.isLoading = payload;
  },
  setEventLogSearchParams(state, payload: SearchParams) {
    state.searchParams = deepClone(payload);
  },
  resetEventLogPaging(state) {
    state.searchParams.dataOption.page = 1;
    state.searchParams.dataOption.itemsPerPage = 10;
    state.searchParams.dataOption.filter = '';
    state.searchParams.filter = '';
  },
};
